import script from "./ProductDetailsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailsCard.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailsCard.vue?vue&type=style&index=0&id=54c4c6a8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c4c6a8"]])

export default __exports__